import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex whitespace-nowrap items-center gap-2" }
const _hoisted_2 = { class: "capitalize" }

import { PhysicalMailShortMessage } from '@/inbox/composition';
import { usePhysicalMail } from '@/messenger';
import { computed } from 'vue';
import { SvgIcon, Tooltip } from '@/ui-kit';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhysicalMailShortMessage',
  props: {
    message: null,
    isUnread: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	message: PhysicalMailShortMessage;
	isUnread: boolean;
};



const { getAddressTitle } = usePhysicalMail();

const status = computed(() => {
	return (
		props.message.content?.status
			?.replace('letter.', '')
			?.replace(/[. _]/gm, ' ') ||
		(props.message as any).status?.replace(
			'letter.',
			''
		)
	);
});

const deliveryDate = computed(() => {
	if (!props.message.content?.expected_delivery_date) {
		return null;
	}
	const [year, month, day] =
		props.message.content?.expected_delivery_date.split(
			'-'
		);

	if (!year || month || day) {
		return null;
	}

	return `${day}/${month}/${year}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["whitespace-nowrap overflow-hidden overflow-ellipsis", 
				__props.isUnread
					? 'text-inbox-gray-theme-600 font-medium'
					: 'text-inbox-gray-theme-600 font-light'
			])
    }, [
      (
					__props.message.content?.direction ===
					'outbound'
				)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("Outbound ")
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode("Inbound")
          ], 64)),
      _createTextVNode(" USPS "),
      (_unref(status))
        ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: _normalizeClass(["ml-2", 
					__props.isUnread
						? 'font-light text-inbox-gray-theme-400'
						: 'text-inbox-gray-theme-400  font-light'
				])
          }, [
            _createTextVNode(" Status: "),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(status)), 1)
          ], 2))
        : _createCommentVNode("", true)
    ], 2),
    (_unref(deliveryDate))
      ? (_openBlock(), _createBlock(_unref(Tooltip), {
          key: 0,
          placement: "bottom",
          delay: { show: 0, hide: 0 }
        }, {
          popper: _withCtx(() => [
            _createTextVNode(" Expected delivery date " + _toDisplayString(_unref(deliveryDate)), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(SvgIcon), {
              class: "h-4 w-4 text-inbox-gray-theme-600",
              name: "calendar"
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})